/**
 * toaster options 
 */
export interface TosterOption {
    top?: string;
    class?: string
  }
  
  export interface TosterData {
    message?: string,
    title?: string,
    type?: ToasterType,
    autoCloseTime? : number, // ex: 7000 milliseconds
    calledBy? : string,
    interactiveElement? : string,
    prevIdToFocus?: string,
    isSnsCheckbox?: boolean,
    interactiveElementLink?: string,
    // Accessible names for the accept/close buttons of the `calledBy: 'weeklyad'` toaster.
    // Both buttons are icon-only, so the caller must describe the action it performs
    // (WCAG 2.2 SC 4.1.2). Defaults are 'Accept' and 'Close'.
    acceptButtonAriaLabel?: string,
    closeButtonAriaLabel?: string,
  }
  
  export enum ToasterType {
    Success = 'Success',
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info'
  }

  export enum ToasterMessages{
    REMOVE_ITEM = "Item Removed",
    REMOVE_CTA = "Remove",
    REMOVE_ACTION_MSG = "Request sent to shopper to add {{quantity}} {{productName}}",
    GOTOCHAT_CTA = "Go to chat",
    GOTOCHAT_MSG = "Currently we are unable to remove the item.Please contact your shopper via chat to remove.",
    REMOVE_ACTION_MSG_FOR_RESTRICTED_ITEM = "A request was sent to your shopper to add {{quantity}} {{productName}}.Someone 21 and over with valid ID must be present to accept this order.",
    TRY_AGAIN_CTA = "Try again",
    TRY_AGAIN_MSG = "Sorry, we weren’t able to add this item. Please try again.",
  }

  export class ToasterMessageHelper {
    static formatRemoveActionMessage(quantity: number, productName: string, isRestrictedItem:boolean): string {
        const template = isRestrictedItem 
            ? ToasterMessages.REMOVE_ACTION_MSG_FOR_RESTRICTED_ITEM 
            : ToasterMessages.REMOVE_ACTION_MSG;
        return template
            .replace('{{quantity}}', quantity.toString())
            .replace('{{productName}}', productName);
    }

    static getErrorMessageBasedOnErrorCode(response?): { message: string; cta: string } {

        const defaultError = {
            message: 'Request timed out. We were unable to add the item. Please try again.',
            cta: ToasterMessages.TRY_AGAIN_CTA
        };

        const tryAgainError = {
            message: ToasterMessages.TRY_AGAIN_MSG,
            cta: ToasterMessages.TRY_AGAIN_CTA
        };

        const errorCode = String(response?.errorCode || response?.statusCode);

        switch (errorCode) {
            case '4001':
            case '4003':
            case '4005':
            case '4006':
            case '4007':
            case '4008':
            case '4009':
            case '500':
            case '404':
                return tryAgainError;

            case '4002':
                return {
                    message: 'Sorry, shopper completed shopping your order. We can no longer accept changes.',
                    cta: ''
                };

            case '4004':
                return {
                    message: response?.errorMessage,
                    cta: ''
                };

            default:
                return defaultError;
        }
    }
}
